module.exports = "<span *ngIf=\"!params.data\" (click)=\"editModel()\"></span>\n"